'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/dayFromNow.js
// module id = 155
// module chunks = 0